import React from 'react';
import { Input } from '@material-ui/core';
import PropTypes from 'prop-types';
import Subtitle2 from '../../../../common/typographys/Subtitle2';

const AddPointNewStandalone = ({ name, onChangeName }) => (
  <>
    <Subtitle2>Nome do ponto de discussão</Subtitle2>
    <Input
      fullWidth
      value={name}
      onChange={e => onChangeName(e.target.value)}
      placeholder="Nome do ponto de discussão"
    />
  </>
);

AddPointNewStandalone.propTypes = {
  name: PropTypes.string.isRequired,
  onChangeName: PropTypes.func.isRequired,
};

export default React.memo(AddPointNewStandalone);
